import z from 'zod';
import arrayEntry from './arrayEntry.js';
import internationalizedArrayPageSectionsValue from '../objects/internationalizedArrayPageSectionsValue.js';
var id = 'internationalizedArrayPageSections';
var fragment = {
    type: 'array',
    of: [
        {
            type: 'internationalizedArrayPageSectionsValue'
        }
    ]
};
var validator = z.array(internationalizedArrayPageSectionsValue.validator.merge(arrayEntry.validator));
export default {
    id: id,
    fragment: fragment,
    validator: validator
};

//# sourceMappingURL=internationalizedArrayPageSections.js.map